import {
  CREATE_ORDERED_PART_MUTATION,
  UPDATE_ORDERED_PART_MUTATION,
} from "../../graphql/mutations/parts/orderedParts.part.mutation";
import { GET_ORDERED_PARTS } from "../../graphql/queries/parts/orderedParts.queries";
import { useMutation, useLazyQuery } from "@apollo/client";

const useOrderedParts = () => {
  const [getOrderedPartsQuery] = useLazyQuery(GET_ORDERED_PARTS, {
    fetchPolicy: "network-only",
  });
  const [updateOrderedPartMutation] = useMutation(UPDATE_ORDERED_PART_MUTATION);
  const [createOrderedPartMutation] = useMutation(CREATE_ORDERED_PART_MUTATION);

  const getOrderedParts = async ({ searchParams = "", orderedPart = {} }) => {
    const { data, error } = await getOrderedPartsQuery({
      variables: { searchParams, orderedPart },
    });
    if (error) {
      console.error(error);
      alert(error);
    }
    return data?.orderedParts;
  };

  const createOrderedPart = async (part) => {
    const { data } = await createOrderedPartMutation(
      {
        variables: {
          orderedPart: {
            name: part.name,
            vendor_part_number: part.vendor_part_number,
            tickets: part.tickets.map((t) => {
              return {
                ticket: t.ticket.toString(),
                id: t.id,
                ticket_id: t?.ticket_id,
              };
            }),
            description: part.description,
            vendor: part.vendor,
            status: part.status,
            ordered_date: part.ordered_date,
            po_number: part.po_number,
            quantity: +part.quantity,
            each_price: +part.each_price,
            shipping_price: +part.shipping_price,
            total_price: +part.total_price,
            payment_method: part.payment_method,
            tracking_number: part.tracking_number,
            eta: part.eta,
            notes: part.notes,
          },
        },
      },
      { fetchPolicy: "network-only" }
    );
    return data;
  };

  const updateOrderedPart = async (part) => {
    if (!part?._id) return console.error("No part id");
    const { data } = await updateOrderedPartMutation(
      {
        variables: {
          _id: part._id,
          orderedPart: {
            name: part.name,
            vendor_part_number: part.vendor_part_number,
            tickets: part.tickets?.map((t) => {
              return { ticket: t.ticket, id: t.id, ticket_id: t?.ticket_id };
            }),
            description: part.description,
            received_date: part.received_date,
            vendor: part.vendor,
            status: part.status,
            ordered_date: part.ordered_date,
            po_number: part.po_number,
            quantity: +part.quantity,
            each_price: +part.each_price,
            shipping_price: +part.shipping_price,
            total_price: +part.total_price,
            payment_method: part.payment_method,
            tracking_number: part.tracking_number,
            eta: part.eta,
            notes: part.notes,
          },
        },
      },
      { fetchPolicy: "network-only" }
    );
    return data?.updateOrderedPart;
  };

  return { createOrderedPart, getOrderedParts, updateOrderedPart };
};

export default useOrderedParts;
